import { Box, Button, Dialog, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, Tab, Tabs, TextField, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useContext } from 'react';
import Header from '../../../../components/Header'
import { UserContext } from '../../../../context/UserContext';
import { tokens } from '../../../../theme';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import axios from 'axios';
import AdDialog from './adDialog';
import BrandSelectionDialog from './brandSelectionDialog';
import { useNavigate } from 'react-router-dom';
import AdBoxForAdmin from '../../../../components/AdBoxForAdmin';
import TargetPointSettingsDialog from './targetPointSettingsDialog';
import InfiniteScroll from 'react-infinite-scroll-component';
import RelatedAdsDialog from './relatedAdsDialog';
import * as yup from "yup";
import { Formik, setIn } from 'formik';
import TabPanel, { a11yProps } from '../../../global/TabPanel';
import IndependentCouponBox from '../../../../components/IndependentCouponBox';
import AlertDialogSlide from '../../../../components/AlertDialogSlide';
import IndependentCouponDialog from '../../../../components/IndependentCouponDialog';
import PurchasableProductsDialog from './purchasableProductsDialog';

function Ads() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { user, token } = useContext(UserContext);
  const navigate = useNavigate();

  const [searchKey, setSearchKey] = useState("");
  const [filter, setFilter] = useState("all");
  const [dialogType, setDialogType] = useState("edit");
  const [ads, setAds] = useState([]);
  const [hasMoreAlcagoAd, setHasMoreAlcagoAd] = useState(true);
  const [targetAdForRelatedAdAddition, setTargetAdForRelatedAdAddition] = useState(null);
  const [adForPurchasableProductsDialog, setAdForPurchasableProductsDialog] = useState(null);
  const [targetAdForDisplayLimitChange, setTargetAdForDisplayLimitChange] = useState(null);
  const [independentCouponToAddOrEdit, setIndependentCouponToAddOrEdit] = useState(null);


  const [brandAds, setBrandAds] = useState([]);
  const [hasMoreBrandAd, setHasMoreBrandAd] = useState(true);
  const [deleteIndependentCouponAlertDialogState, setDeleteIndependentCouponAlertDialogState] = useState({
    open: false,
    selectedCoupon: null
  });


  const [tabIndex, setTabIndex] = useState(0);

  const handleTabIndexChange = (event, newValue) => {
    setTabIndex(newValue);
  };


  const fetchAlcagoAds = (startIndex) => {
    axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getAdsWithFilter?token=${token}&filter=${filter}&searchKey=${searchKey}&startIndex=${startIndex}&limit=10`)
      .catch((err) => {
        console.log("err: " + err);
        if (err.response.data.status === 404) {
          setHasMoreAlcagoAd(false);
        }
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 200) {
          setHasMoreAlcagoAd(response.data.ads && response.data.ads.length === 10);
          if (startIndex === 0) {
            setAds([...response.data.ads]);
          } else {
            setAds((prev) => [...prev, ...response.data.ads]);
          }
        }
      });
  }


  const fetchBrandAds = (startIndex) => {
    axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/brand/getIndependentCoupons?token=${token}&startIndex=${startIndex}&limit=10`, {
      searchKey: searchKey
    })
      .catch((err) => {
        console.log("err: " + err);
        if (err.response.data.status === 404) {
          setHasMoreBrandAd(false);
        }
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 200) {
          setHasMoreBrandAd(response.data.independentCoupons && response.data.independentCoupons.length === 10);
          if (startIndex === 0) {
            setBrandAds([...response.data.independentCoupons]);
          } else {
            setBrandAds((prev) => [...prev, ...response.data.independentCoupons]);
          }
        }
      });
  }

  useEffect(() => {
    if (tabIndex === 0) {
      fetchAlcagoAds(0);
      setBrandAds([]);
      setHasMoreBrandAd(true);
    } else if (tabIndex === 1) {
      fetchBrandAds(0);
      setAds([]);
      setHasMoreAlcagoAd(true);
    }
  }, [tabIndex]);

  const [openBrandSelectionDialog, setOpenBrandSelectionDialog] = useState(false);


  const handleBrandSelectionDialogClose = (ad) => {
    if (ad) {
      if (tabIndex === 0) {
        setDialogType("add")
        ad.is_active = 1;
        setSelectedAd(ad);
        setOpenBrandSelectionDialog(false);
        setOpenAdDialog(true);
      } else if (tabIndex === 1) {
        console.log(ad);
        setIndependentCouponToAddOrEdit({
          brand_id: ad.brand_id,
        });
        setOpenBrandSelectionDialog(false);
      }
    } else {
      setOpenBrandSelectionDialog(false);
    }
  }


  const [openTargetPointSettingsDialog, setOpenTargetPointSettingsDialog] = useState(false);


  const handleTargetPointSettingsDialogClose = () => {
    setOpenTargetPointSettingsDialog(false);
  }

  const [openAdDialog, setOpenAdDialog] = useState(false);
  const [selectedAd, setSelectedAd] = useState({});

  const handleAdDialogClose = () => {
    setOpenAdDialog(false);
    setSelectedAd({});
    fetchAlcagoAds(0);
  }

  const handleAdSelection = (ad) => {
    setDialogType(ad.is_active ? "edit" : "approve")
    axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getAdDetails?token=${token}&id=${ad.id}`)
      .catch((err) => {
        console.log("err: " + err);
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 200) {
          ad.bubbles = response.data.ad.bubbles;
          ad.questions = response.data.ad.questions;
          for (var i = 0; i < ad.bubbles.length; ++i) {
            ad.bubbles[i].appaer_time = ((ad.bubbles[i].appaer_time / 1000 / 60) < 10 ? ("0" + parseInt(ad.bubbles[i].appaer_time / 1000 / 60)) : parseInt(ad.bubbles[i].appaer_time / 1000 / 60)) + ":" + (((ad.bubbles[i].appaer_time / 1000) % 60) < 10 ? ("0" + parseInt((ad.bubbles[i].appaer_time / 1000) % 60)) : parseInt((ad.bubbles[i].appaer_time / 1000) % 60));
            ad.bubbles[i].show_time = ad.bubbles[i].show_time / 1000;
          }
          setSelectedAd(ad);
          setOpenAdDialog(true);
        }
      });
  }

  const updateDisplayLimit = (displayLimit) => {
    axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/ad/updateAd?token=${token}&adId=${targetAdForDisplayLimitChange.id}`, {
      ad: {
        display_limit: displayLimit
      }
    })
      .catch((err) => {
        console.log("err: " + err);
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 201) {
          fetchAlcagoAds(0);
          handleDisplayLimitDialogClose();
        }
      });
  }

  const [openRelatedAdsDialog, setOpenRelatedAdsDialog] = useState(false);

  const handleRelatedAdsDialogClose = () => {
    setOpenRelatedAdsDialog(false);
    setTargetAdForRelatedAdAddition(null);
  }

  useEffect(() => {
    if (targetAdForRelatedAdAddition) {
      setOpenRelatedAdsDialog(true);
    }
  }, [targetAdForRelatedAdAddition]);

  const [openDisplayLimitDialog, setOpenDisplayLimitDialog] = useState(false);

  const handleDisplayLimitDialogClose = () => {
    setOpenDisplayLimitDialog(false);
    setTargetAdForDisplayLimitChange(null);
  }

  useEffect(() => {
    if (targetAdForDisplayLimitChange) {
      setOpenDisplayLimitDialog(true);
    }
  }, [targetAdForDisplayLimitChange]);

  const handleDeleteIndependentCouponAlertDialogClose = () => {
    setDeleteIndependentCouponAlertDialogState({
      open: false,
      selectedCoupon: null
    });
  }

  const deleteIndependentCoupon = (independentCouponId) => {
    axios.delete(`${process.env.REACT_APP_API_URL}api/alcago/brand/deleteIndependentCoupon?token=${token}&independentCouponId=${independentCouponId}`)
      .catch((err) => {
        console.log("err: " + err);
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 201) {
          fetchBrandAds(0);
          handleDeleteIndependentCouponAlertDialogClose();
        }
      });
  }

  const createIndependentCoupon = async (values) => {
    if (values.thumbnail || values.thumbnail1 || values.thumbnail2 || values.thumbnail3 || values.thumbnail4 || values.thumbnail5 || values.thumbnail6) {
      await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/uploadIndependentCouponThumbnail?token=${token}`, {
        ...(values.thumbnail ? { thumbnail: values.thumbnail } : {}),
        ...(values.thumbnail1 ? { thumbnail1: values.thumbnail1 } : {}),
        ...(values.thumbnail2 ? { thumbnail2: values.thumbnail2 } : {}),
        ...(values.thumbnail3 ? { thumbnail3: values.thumbnail3 } : {}),
        ...(values.thumbnail4 ? { thumbnail4: values.thumbnail4 } : {}),
        ...(values.thumbnail5 ? { thumbnail5: values.thumbnail5 } : {}),
        ...(values.thumbnail6 ? { thumbnail6: values.thumbnail6 } : {})
      }, {
        headers: {
          "content-type": "multipart/form-data"
        }
      })
        .catch((err) => {
          console.log("err: " + err);
        })
        .then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            if (values.thumbnail) {
              delete values.thumbnail;
              delete values.thumbnail_image_link;
              values.thumbnail_image_path = response.data.thumbnailPath;
            }
            if (values.thumbnail1) {
              delete values.thumbnail1;
              delete values.thumbnail_image_1_path;
              values.thumbnail_image_1_path = response.data.thumbnailPath1;
            }
            if (values.thumbnail2) {
              delete values.thumbnail2;
              delete values.thumbnail_image_2_path;
              values.thumbnail_image_2_path = response.data.thumbnailPath2;
            }
            if (values.thumbnail3) {
              delete values.thumbnail3;
              delete values.thumbnail_image_3_path;
              values.thumbnail_image_3_path = response.data.thumbnailPath3;
            }
            if (values.thumbnail4) {
              delete values.thumbnail4;
              delete values.thumbnail_image_4_path;
              values.thumbnail_image_4_path = response.data.thumbnailPath4;
            }
            if (values.thumbnail5) {
              delete values.thumbnail5;
              delete values.thumbnail_image_5_path;
              values.thumbnail_image_5_path = response.data.thumbnailPath5;
            }
            if (values.thumbnail6) {
              delete values.thumbnail6;
              delete values.thumbnail_image_6_path;
              values.thumbnail_image_6_path = response.data.thumbnailPath6;
            }
          }
        });
    }
    delete values.thumbnail;
    delete values.thumbnail_image_link;
    delete values.thumbnail1;
    delete values.thumbnail_image_1_link;
    delete values.thumbnail2;
    delete values.thumbnail_image_2_link;
    delete values.thumbnail3;
    delete values.thumbnail_image_3_link;
    delete values.thumbnail4;
    delete values.thumbnail_image_4_link;
    delete values.thumbnail5;
    delete values.thumbnail_image_5_link;
    delete values.thumbnail6;
    delete values.thumbnail_image_6_link;
    axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/createIndependentCoupon?token=${token}`, values)
      .catch((err) => {
        console.log("err: " + err);
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 201) {
          setIndependentCouponToAddOrEdit(null);
          fetchBrandAds(0);
        }
      });
  }

  const editIndependentCoupon = async (independentCouponId, values) => {
    if (values.thumbnail || values.thumbnail1 || values.thumbnail2 || values.thumbnail3 || values.thumbnail4 || values.thumbnail5 || values.thumbnail6) {
      await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/uploadIndependentCouponThumbnail?token=${token}`, {
        ...(values.thumbnail ? { thumbnail: values.thumbnail } : {}),
        ...(values.thumbnail1 ? { thumbnail1: values.thumbnail1 } : {}),
        ...(values.thumbnail2 ? { thumbnail2: values.thumbnail2 } : {}),
        ...(values.thumbnail3 ? { thumbnail3: values.thumbnail3 } : {}),
        ...(values.thumbnail4 ? { thumbnail4: values.thumbnail4 } : {}),
        ...(values.thumbnail5 ? { thumbnail5: values.thumbnail5 } : {}),
        ...(values.thumbnail6 ? { thumbnail6: values.thumbnail6 } : {})
      }, {
        headers: {
          "content-type": "multipart/form-data"
        }
      })
        .catch((err) => {
          console.log("err: " + err);
        })
        .then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            if (values.thumbnail) {
              delete values.thumbnail;
              delete values.thumbnail_image_link;
              values.thumbnail_image_path = response.data.thumbnailPath;
            }
            if (values.thumbnail1) {
              delete values.thumbnail1;
              delete values.thumbnail_image_1_path;
              values.thumbnail_image_1_path = response.data.thumbnailPath1;
            }
            if (values.thumbnail2) {
              delete values.thumbnail2;
              delete values.thumbnail_image_2_path;
              values.thumbnail_image_2_path = response.data.thumbnailPath2;
            }
            if (values.thumbnail3) {
              delete values.thumbnail3;
              delete values.thumbnail_image_3_path;
              values.thumbnail_image_3_path = response.data.thumbnailPath3;
            }
            if (values.thumbnail4) {
              delete values.thumbnail4;
              delete values.thumbnail_image_4_path;
              values.thumbnail_image_4_path = response.data.thumbnailPath4;
            }
            if (values.thumbnail5) {
              delete values.thumbnail5;
              delete values.thumbnail_image_5_path;
              values.thumbnail_image_5_path = response.data.thumbnailPath5;
            }
            if (values.thumbnail6) {
              delete values.thumbnail6;
              delete values.thumbnail_image_6_path;
              values.thumbnail_image_6_path = response.data.thumbnailPath6;
            }
          }
        });
    }

    delete values.thumbnail;
    delete values.thumbnail_image_link;
    delete values.thumbnail1;
    delete values.thumbnail_image_1_link;
    delete values.thumbnail2;
    delete values.thumbnail_image_2_link;
    delete values.thumbnail3;
    delete values.thumbnail_image_3_link;
    delete values.thumbnail4;
    delete values.thumbnail_image_4_link;
    delete values.thumbnail5;
    delete values.thumbnail_image_5_link;
    delete values.thumbnail6;
    delete values.thumbnail_image_6_link;

    axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/brand/updateIndependentCoupon?token=${token}&independentCouponId=${independentCouponId}`, {
      independentCoupon: values
    })
      .catch((err) => {
        console.log("err: " + err);
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 201) {
          setIndependentCouponToAddOrEdit(null);
          fetchBrandAds(0);
        }
      });
  }

  return (
    <Box m="20px 0 20px 20px">
      {selectedAd && selectedAd.brand_id && <AdDialog open={openAdDialog} handleClose={handleAdDialogClose} type={dialogType} isAdmin={true} selectedAd={selectedAd} />}
      {
        !!independentCouponToAddOrEdit &&
        <IndependentCouponDialog
          open={independentCouponToAddOrEdit !== null}
          handleClose={() => {
            setIndependentCouponToAddOrEdit(null);
          }}
          independentCoupon={independentCouponToAddOrEdit}
          handleSubmit={(values) => {
            if (independentCouponToAddOrEdit.id) {
              editIndependentCoupon(independentCouponToAddOrEdit.id, values);
            } else {
              createIndependentCoupon({ ...values, brand_id: independentCouponToAddOrEdit.brand_id });
            }
          }}
        />
      }
      {adForPurchasableProductsDialog && <PurchasableProductsDialog open={adForPurchasableProductsDialog !== null} handleClose={() => setAdForPurchasableProductsDialog(null)} targetAd={adForPurchasableProductsDialog} />}
      {openRelatedAdsDialog && <RelatedAdsDialog open={openRelatedAdsDialog} handleClose={handleRelatedAdsDialogClose} targetAd={targetAdForRelatedAdAddition} />}
      {
        openDisplayLimitDialog &&
        <Dialog
          sx={{ margin: "0 auto" }} open={openDisplayLimitDialog}
          onClose={handleDisplayLimitDialogClose}>
          <Box minWidth="300px" m="20px" textAlign="center">
            <Formik
              initialValues={{
                display_limit: targetAdForDisplayLimitChange.display_limit
              }}
              validationSchema={yup.object().shape({
                display_limit: yup.number().required("Bu alan boş bırakılamaz").min(0, "En az 0 olabilir")
              })}
              onSubmit={(values) => {
                updateDisplayLimit(values.display_limit);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Box>
                    <TextField
                      id="display_limit"
                      name="display_limit"
                      label="Gösterim Limiti"
                      variant="outlined"
                      value={values.display_limit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.display_limit && Boolean(errors.display_limit)}
                      helperText={touched.display_limit && errors.display_limit}
                    />
                  </Box>
                  <Box mt="20px" display="flex" justifyContent="center">
                    <Button variant='contained' color='primary' type="submit">
                      Kaydet
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
          </Box>
        </Dialog>
      }
      <BrandSelectionDialog open={openBrandSelectionDialog} handleClose={handleBrandSelectionDialogClose} />
      <TargetPointSettingsDialog open={openTargetPointSettingsDialog} handleClose={handleTargetPointSettingsDialogClose} />
      {
        (deleteIndependentCouponAlertDialogState.open && deleteIndependentCouponAlertDialogState.selectedCoupon) &&
        <AlertDialogSlide
          open={deleteIndependentCouponAlertDialogState.open} handleClose={handleDeleteIndependentCouponAlertDialogClose}
          clickPositiveAnswer={() => {
            deleteIndependentCoupon(deleteIndependentCouponAlertDialogState.selectedCoupon.id);
          }} clickNegativeAnswer={() => { }}
          positiveAnswer={"Sil"} negativeAnswer={"İptal"}
          title={"Bu kampanyayı silmek istediğinize emin misiniz?"}
          description={"Bu kampanya ile ilişkili tüm veriler silinecektir. (İstatistikler vb.)"}
        />
      }
      <Box ml="20px" display="flex" gap="20px">
        <Box width="20%">
          <Header title="Reklamlar" subtitle="Yeni reklam ekleyebilir, onaylanmamış reklamları onaylayabilir, mevcut reklamları düzenleyebilirsiniz." />
        </Box>
        <TextField
          id="outlined-basic"
          label="Marka Adı / Kategori"
          variant="outlined"
          onChange={(event) => {
            setSearchKey(event.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {tabIndex === 0 &&
                  <FormControl fullWidth variant="filled">
                    <InputLabel id="filter-label">Filtrele</InputLabel>
                    <Select
                      labelId="filter-label"
                      id="filter-select"
                      label="Filtrele"
                      value={filter}
                      onChange={(event) => setFilter(event.target.value)}
                    >
                      <MenuItem value={"all"}>Tümü</MenuItem>
                      <MenuItem value={"active"}>Aktif</MenuItem>
                      <MenuItem value={"passive"}>Onay Bekleyen</MenuItem>
                    </Select>
                  </FormControl>
                }
                <IconButton onClick={() => tabIndex === 0 ? fetchAlcagoAds(0) : fetchBrandAds(0)} sx={{ marginLeft: "10px" }}>
                  <SearchOutlinedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }} />
        <Button variant='contained' color='success' sx={{ margin: "10px 0 auto 0" }} onClick={() => {
          setOpenBrandSelectionDialog(true);
        }}>
          Yeni Reklam Ekle
        </Button>

        <Button variant='contained' color='warning' sx={{ margin: "10px 0 auto 0" }} onClick={() => {
          setOpenTargetPointSettingsDialog(true);
        }}>
          Hedefleme Ayarları
        </Button>

        <Button variant='contained' color='warning' sx={{ margin: "10px 0 auto 0" }} onClick={() =>
          navigate(`/admin-panel/additional-ap-campaigns`)
        }>
          Ek AP Kampanyaları
        </Button>
      </Box>
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabIndexChange}
            textColor={theme.palette.mode === "dark" ? "secondary" : "primary"}
            indicatorColor={theme.palette.mode === "dark" ? "secondary" : "primary"}>
            <Tab label="Alcago Kampanyaları" {...a11yProps(0)} />
            <Tab label="Marka Kampanyaları" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <Box mt="10px">

          <TabPanel value={tabIndex} index={0}>
            <InfiniteScroll
              dataLength={ads.length}
              next={() => fetchAlcagoAds(ads.length)}
              hasMore={hasMoreAlcagoAd}
              loader={<h4>Yükleniyor...</h4>}
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>Tüm Alcago Kampanyalarını Görüntülüyorsunuz.</b>
                </p>
              }
            >
              {ads.map(
                (ad) =>
                  <AdBoxForAdmin
                    key={"ad" + ad.id}
                    ad={ad}
                    handleAdSelection={handleAdSelection}
                    handleRelatedAdsAddition={(ad) => setTargetAdForRelatedAdAddition(ad)}
                    openPurchasableProductsDialog={(ad) => setAdForPurchasableProductsDialog(ad)}
                    handleDisplayLimitChange={(ad) => setTargetAdForDisplayLimitChange(ad)} />
              )}
            </InfiniteScroll>
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <InfiniteScroll
              dataLength={brandAds.length}
              next={() => fetchBrandAds(brandAds.length)}
              hasMore={hasMoreBrandAd}
              loader={<h4>Yükleniyor...</h4>}
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>Tüm Marka Kampanyalarını Görüntülüyorsunuz.</b>
                </p>
              }
            >
              {brandAds.map((ad) =>
                <IndependentCouponBox
                  key={ad.id + "independentCoupons"}
                  independentCoupon={ad}
                  onEditClick={(coupon) => {
                    setIndependentCouponToAddOrEdit(coupon);
                  }}
                  onDeleteClick={(coupon) => {
                    setDeleteIndependentCouponAlertDialogState({
                      open: true,
                      selectedCoupon: coupon
                    });
                  }}
                />
              )}
            </InfiniteScroll>
          </TabPanel>

        </Box>
      </Box>
    </Box>

  )
}

export default Ads